import React from "react";
import { CompanyDetails } from "../data-access/types";
import { useTranslation } from "react-i18next";
import { Paper } from "@mui/material";
import { Details } from "src/shared/components/Details";
import { DetailsRow } from "src/shared/components/Details/types";

export default function CompanyInfo({
  companyDetails,
}: {
  companyDetails: CompanyDetails;
}) {
  const { t } = useTranslation();

  const rows = [
    {
      name: t("ΑρΓεΜΗ"),
      value: companyDetails.argemi,
    },
    {
      name: t("Αρμόδια Υπηρεσία Γ.Ε.ΜΗ."),
      value: companyDetails.chamberDescr,
    },
    {
      name: t("ΑΜ Υ. Γ.Ε.ΜΗ."),
      value: companyDetails.gemiRegistryNumber,
    },
    {
      name: t("ΑΦΜ"),
      value: companyDetails.afm,
    },
    {
      name: t("Κατάσταση"),
      value: companyDetails.companyStatus,
    },
    {
      name: t("Αρ. ΜΑΕ"),
      value: companyDetails.armae,
    },
    {
      name: t("Επωνυμία"),
      value: companyDetails.co_name,
    },
    {
      name: t("Διεύθυνση"),
      value:
        companyDetails.address ?? "" + companyDetails.address_zip_code ?? "",
    },
    {
      name: t("Πόλη"),
      value: companyDetails.address_city,
    },
    {
      name: t("Δήμος"),
      value: `${companyDetails.dhmos} `,
    },
    {
      name: t("Υπεύθυνος Επικοινωνίας"),
      value: companyDetails.m01_name,
    },
    {
      name: t("Τηλέφωνο Επικοινωνίας"),
      value: companyDetails.m01_phone,
    },
    {
      name: t("Email Επικοινωνίας"),
      value: companyDetails.m01_email,
    },
    {
      name: t("Κεφάλαιο"),
      value: companyDetails.capital_stock,
    },
    {
      name: t("BusinessRegistry"),
      value: companyDetails.argemi && (
        <a
          href={`${
            import.meta.env.VITE_REGISTRY_URL
          }/business/show/${companyDetails.argemi}`}
          target="_blank"
        >
          {t("Προβολή")}
        </a>
      ),
    },
  ].filter(Boolean);

  return (
    <Paper sx={{ padding: "1rem" }}>
      <h3>{t("Βασικά Στοιχεία Επιχείρησης")}</h3>
      <Details rows={rows as DetailsRow[]} />
    </Paper>
  );
}
